export enum RunInContentAds {
  anywhere = 0,
  onlyAfterTextParagraphs = 1,
  onlyBetweenTextParagraphs = 2
}
